<template>
  <!-- Radio semantics on a div: the Spread evenly card holds a stepper with its own buttons,
       and a <button> cannot contain buttons. -->
  <div
    class="relative flex flex-1 cursor-pointer flex-col gap-2 rounded-xl border bg-white px-4 py-3.5 text-left"
    :class="[selected ? 'border-2 border-blue-600 shadow-[0_0_0_4px_#eff6ff]' : 'border-gray-200', disabled ? 'pointer-events-none opacity-55' : '']"
    role="radio"
    :aria-checked="selected"
    :tabindex="disabled ? -1 : 0"
    :title="tooltip"
    @click="$emit('select')"
    @keydown.enter.self.prevent="$emit('select')"
    @keydown.space.self.prevent="$emit('select')"
  >
    <span class="absolute right-3 top-3 h-[18px] w-[18px] rounded-full border-[1.5px]" :class="selected ? 'border-blue-600 bg-blue-600' : 'border-gray-300'" aria-hidden="true">
      <svg
        v-if="selected"
        class="h-full w-full p-[3px] text-white"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M20 6L9 17l-5-5" />
      </svg>
    </span>
    <span class="inline-flex items-center gap-2 text-sm font-bold text-gray-900">
      <span :class="selected ? 'text-blue-600' : 'text-gray-400'"><slot name="icon" /></span>
      {{ title }}
      <slot name="title-extra" />
    </span>
    <span class="text-xs leading-snug text-gray-500">{{ description }}</span>
    <span class="inline-flex items-center gap-1.5 text-xs font-semibold" :class="toneClass">
      <i class="inline-block h-2 w-2 rounded-full bg-current" aria-hidden="true" />
      {{ consequence.text }}
    </span>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import type { ConsequenceLine } from '@/composables/useSplitAcrossWeeks';

  const props = defineProps<{
    title: string;
    description: string;
    tooltip: string;
    consequence: ConsequenceLine;
    selected: boolean;
    disabled: boolean;
  }>();

  defineEmits<{ select: [] }>();

  const toneClass = computed(() => ({ ok: 'text-green-600', warn: 'text-amber-600', bad: 'text-red-600' })[props.consequence.tone]);
</script>
